import { render, staticRenderFns } from "./sidebar_menu.vue?vue&type=template&id=64a5877d&scoped=true&"
import script from "./sidebar_menu.vue?vue&type=script&lang=js&"
export * from "./sidebar_menu.vue?vue&type=script&lang=js&"
import style0 from "./sidebar_menu.vue?vue&type=style&index=0&id=64a5877d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5877d",
  null
  
)

export default component.exports